export default {
  username: 'Benutzername',
  password: 'Passwort',
  submit: 'Login',
  continue: 'Ohne Anmeldung fortfahren',
  // error: 'Benutzername oder Passwort ist falsch',
  error:
    "C'è un errore oppure l'username o la password sono errati.<br/> La pagina verrà ricaricata tra qualche secondo oppure procedi manualmente.",
}
